import { gql } from '@apollo/client';

export const GET_REWARD_CONFIG = gql`
  query GetRewardConfig {
    getRewardConfig {
      nonRewardableChunkAmount
      subscriptionRewardAmount
    }
  }
`;

export const GET_REWARDS_BY_USER = gql`
  query GetRewardsByUser($userId: ID!) {
    getRewardsByUser(userId: $userId) {
      id
      userId
      orderId
      productId
      reason
      amount
      createdAt
    }
  }
`;


/*muation*/
export const UPDATE_REWARD_CONFIG = gql`
  mutation UpdateRewardConfig($nonRewardableChunkAmount: Float!, $subscriptionRewardAmount: Float!) {
    updateRewardConfig(
      nonRewardableChunkAmount: $nonRewardableChunkAmount,
      subscriptionRewardAmount: $subscriptionRewardAmount
    ) {
      nonRewardableChunkAmount
      subscriptionRewardAmount
    }
  }
`;


export const GET_REWARDS_BY_SEQUENCE = gql`
  query GetRewardsBySequence($sequenceId: String!) {
    getRewardsBySequence(sequenceId: $sequenceId) {
      id
      orderId
      userId
      reason
      amount
      rewardCount
      rewardReset
      isRewardActive
      createdAt
      rewardSeq
      parentRewardSeq
      sequenceSteps {
        stepIndex
        value
        sequenceID
      }
      transactions {
        id
        amount
        transactionType
        type
        createdAt
      }
    }
  }
`;

export const GET_REWARD_SEQUENCES = gql`
  query {
    rewardSequences {
      sequenceID
      step_1
      step_2
      step_3
      step_4
      step_5
      step_6
      step_7
      step_8
      step_9
      step_10
      step_11
      step_12
      step_13
      step_14
      step_15
      step_16
      step_17
      step_18
      step_19
      step_20
      step_21
      step_22
      step_23
      step_24
      step_25
      step_26
      step_27
      step_28
    }
  }
`;

export const GET_ALL_REWARD_DETAILS = gql`
  query GetAllRewardDetails {
    getAllRewardDetails {
      userId
      idFund
      walletBalance
      totalEarned
      totalUsed
      totalLoyaltyIds
      activeQueueEntries

      loyaltyIds {
        id
        idCode
        userId
        source
        createdAt
      }

      queueEntries {
        id
        userId
        queuePosition
        joinDate
        rejoinCount
        isActive
      }
    }
  }
`;
